import PropTypes from "prop-types";
import Link from "next/link";
import CustomImage from "../../../components/atoms/customImage";
/**
 * Renders a limited catalog promotional card with a background gradient, text, and optional image.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {string} props.message - The message or label to be displayed inside the card.
 * @param {string} props.href - The URL to which the card links.
 * @param {string} props.image - The source URL of the image to be displayed (optional).
 * @param {Object} props.backgroundColor - The background color configuration for the card.
 * @param {string} props.backgroundColor.startColor - The start color of the gradient.
 * @param {string} props.backgroundColor.endColor - The end color of the gradient.
 * @param {string} props.textColor - The color of the text inside the card.
 * @returns {JSX.Element} The rendered limited catalog component.
 */
const LimitedCatalog = ({ message, href, image, backgroundColor, textColor, onClickOverCatalog }) => {
  return (
    <div className="mt-16">
      <Link
        href={`/${href}`}
        className={`relative flex rounded-full border-1 border-darkOliveGreen/10 p-4 pr-40`}
        style={{
          background: `linear-gradient(to right, ${backgroundColor.startColor} , ${backgroundColor.endColor})`,
        }}
        onClick={onClickOverCatalog}
      >
        {image && <CustomImage src={image} width={40} height={40} className="mr-8" alt="limited catalogue" />}
        <p className="flex items-center text-12 font-500" style={{ color: textColor }}>
          <span className="mr-8">{message}</span>
        </p>
        <div className="absolute inset-y-0 right-0 top-0 flex h-full items-center justify-center p-12">
          <CustomImage src="/icons/green-chevron.svg" width={16} height={16} isPriority={false} alt="green-chevron" />
        </div>
      </Link>
    </div>
  );
};
LimitedCatalog.propTypes = {
  message: PropTypes.string.isRequired, // The message inside the card is required and must be a string
  href: PropTypes.string.isRequired, // The href URL is required and must be a string
  image: PropTypes.string, // The image source URL is optional and must be a string
  backgroundColor: PropTypes.shape({
    startColor: PropTypes.string.isRequired, // startColor in backgroundColor is required and must be a string
    endColor: PropTypes.string.isRequired, // endColor in backgroundColor is required and must be a string
  }).isRequired, // backgroundColor is required
  textColor: PropTypes.string.isRequired, // The text color is required and must be a string
  onClickOverCatalog: PropTypes.object,
};
export default LimitedCatalog;
